import {appConfig} from 'src/shared/config'

import {addLeadingSlash} from './add-leading-slash'

/**
 * Функция расширяет переданный URL, добавляя к нему basename из настроек приложения,
 * если basename указан. Если basename отсутствует, возвращает URL без изменений.
 *
 * @param {string} url URL, который нужно расширить.
 * @return {string} Расширенный URL с добавленным basename или исходный URL, если basename не указан.
 */
export function extendUrlByBasename(url: string): string {
  const basename = appConfig.basename
  const urlWithLeadingSlash = addLeadingSlash(url)

  return basename ? `/${basename}${urlWithLeadingSlash}` : urlWithLeadingSlash
}
